import { useState } from "react";
import { fetchRegistrationsReportCsv } from "../api/fetchRegistrationsReport/fetchRegistrationsReportCsvApi";
import { FetchRegistrationsReportParams } from "../api/fetchRegistrationsReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadRegistrationsReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchRegistrationsReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchRegistrationsReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `registrations-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
